import React from "react";
function Header() {
  return (
    <>
      <header>
        <h1>मधु श्री सट्टा मटका</h1>
        <p>भारत का भरोसेमंद मटका प्लेटफार्म</p>
      </header>
    </>
  );
}

export default Header;
